/**
 * @flow
 * @relayHash 7ac8cb088f37be4e8106b589ff66bbea
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Screen_screen$ref = any;
export type ScreenRefetchQueryVariables = {|
  index?: ?number
|};
export type ScreenRefetchQueryResponse = {|
  +screen: ?{|
    +$fragmentRefs: Screen_screen$ref
  |}
|};
*/


/*
query ScreenRefetchQuery(
  $index: Int
) {
  screen: screen(index: $index) {
    ...Screen_screen
    id
  }
}

fragment Screen_screen on Screen {
  id
  index
  rowset {
    fields {
      name
      label
    }
    rows
  }
  name
  html
  json
  duration
  contentType
  dataSource
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "index",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "index",
    "variableName": "index",
    "type": "Int"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ScreenRefetchQuery",
  "id": null,
  "text": "query ScreenRefetchQuery(\n  $index: Int\n) {\n  screen: screen(index: $index) {\n    ...Screen_screen\n    id\n  }\n}\n\nfragment Screen_screen on Screen {\n  id\n  index\n  rowset {\n    fields {\n      name\n      label\n    }\n    rows\n  }\n  name\n  html\n  json\n  duration\n  contentType\n  dataSource\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ScreenRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "screen",
        "name": "screen",
        "storageKey": null,
        "args": v1,
        "concreteType": "Screen",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Screen_screen",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ScreenRefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "screen",
        "name": "screen",
        "storageKey": null,
        "args": v1,
        "concreteType": "Screen",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "index",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "rowset",
            "storageKey": null,
            "args": null,
            "concreteType": "RowSet",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "fields",
                "storageKey": null,
                "args": null,
                "concreteType": "FieldDefinition",
                "plural": true,
                "selections": [
                  v2,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "label",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rows",
                "args": null,
                "storageKey": null
              }
            ]
          },
          v2,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "html",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "json",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "duration",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contentType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "dataSource",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1cec669fef155b9cf643372fae1c868d';
module.exports = node;



// WEBPACK FOOTER //
// ./src/scenes/Screen/__generated__/ScreenRefetchQuery.graphql.js